import React, { useState, useEffect } from "react";

const API_URL = "https://pro-erp-system.stacknet.lk/items/api/public";
const PLACEHOLDER =
  "https://placehold.co/800x800/1a1a1a/ef4444?text=No+Image";

const CategoryPage = ({ categoryName }) => {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(API_URL)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const cat = data.categories.find(
            (c) => c.name.toLowerCase() === categoryName.toLowerCase()
          );
          setProducts(cat ? cat.products : []);
        } else {
          setError("Unable to load products.");
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Network error.");
        setLoading(false);
      });
  }, [categoryName]);

  const filtered = products.filter((p) =>
    p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleWhatsApp = (product) => {
    const message = `Hi, I'm interested in ${product.name}. Please share details.`;
    window.open(
      `https://api.whatsapp.com/send?phone=+94765794062&text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#080808",
        color: "#fff",
        fontFamily: "'Barlow Condensed', 'Impact', sans-serif",
        padding: "0 2.5rem 4rem",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800;900&family=Barlow:wght@400;500;600&display=swap');
        * { box-sizing: border-box; }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .product-card {
          background: #111;
          border: 1px solid #1f1f1f;
          border-radius: 8px;
          overflow: hidden;
          cursor: pointer;
          transition: border-color 0.25s, transform 0.25s;
        }

        .product-card:hover {
          border-color: #ef4444;
          transform: translateY(-3px);
        }

        .product-card img {
          width: 100%;
          height: 220px;
          object-fit: contain;
          display: block;
          background: #fff;
          padding: 10px;
        }

        .product-card:hover img {
          transform: scale(1.05);
        }

        .search-input {
          background: #111;
          border: 1px solid #1f1f1f;
          color: #fff;
          padding: 11px 16px;
          border-radius: 3px;
          font-family: 'Barlow', sans-serif;
          font-size: 0.9rem;
          outline: none;
          width: 100%;
          max-width: 380px;
        }

        .search-input:focus {
          border-color: #ef4444;
        }

        .overlay-btn-primary {
          width: 100%;
          background: #ef4444;
          color: #fff;
          border: none;
          padding: 13px;
          border-radius: 3px;
          font-weight: 700;
          cursor: pointer;
        }

        .overlay-btn-secondary {
          width: 100%;
          background: none;
          color: #9ca3af;
          border: 1px solid #1f1f1f;
          padding: 12px;
          border-radius: 3px;
          font-weight: 600;
          cursor: pointer;
        }
      `}</style>

      {/* HEADER */}
      <div
        style={{
          paddingTop: "3rem",
          paddingBottom: "2.5rem",
          borderBottom: "1px solid #1f1f1f",
          marginBottom: "2.5rem",
        }}
      >
        <h1 style={{ fontSize: "3rem", fontWeight: 900 }}>
          {categoryName}
        </h1>

        <p style={{ color: "#4b5563" }}>
          {products.length} products available
        </p>

        <input
          type="text"
          placeholder="Search products..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      {/* LOADING */}
      {loading && <p>Loading products...</p>}

      {/* ERROR */}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* GRID */}
      {!loading && !error && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(210px, 1fr))",
            gap: "1.5rem",
          }}
        >
          {filtered.length > 0 ? (
            filtered.map((product) => (
              <div
                key={product.id}
                className="product-card"
                onClick={() => setSelectedProduct(product)}
                style={{ animation: "fadeUp 0.4s ease both" }}
              >
                <img
                  src={product.image || PLACEHOLDER}
                  alt={product.name}
                />

                <div style={{ padding: "14px 16px" }}>
                  <h3 style={{ fontWeight: 700 }}>
                    {product.name}
                  </h3>
                  <p style={{ color: "#ef4444", fontSize: "0.75rem" }}>
                    View Details →
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p style={{ gridColumn: "1/-1", textAlign: "center" }}>
              No products found
            </p>
          )}
        </div>
      )}

      {/* OVERLAY */}
      {selectedProduct && (
        <div
            style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.85)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999,
            }}
        >
            <div
            style={{
                background: "#0f0f0f",
                padding: "1.5rem",
                maxWidth: "420px",
                width: "100%",
                borderRadius: "8px",
            }}
            >
            {/* IMAGE ADDED HERE 🔥 */}
            <div
                style={{
                width: "100%",
                height: "260px",
                background: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "1rem",
                borderRadius: "6px",
                overflow: "hidden",
                }}
            >
                <img
                src={selectedProduct.image || PLACEHOLDER}
                alt={selectedProduct.name}
                style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                }}
                onError={(e) => (e.target.src = PLACEHOLDER)}
                />
            </div>

            <h2 style={{ marginBottom: "1rem" }}>
                {selectedProduct.name}
            </h2>

            <button
                className="overlay-btn-primary"
                onClick={() => handleWhatsApp(selectedProduct)}
            >
                Order via WhatsApp
            </button>

            <button
                className="overlay-btn-secondary"
                onClick={() => setSelectedProduct(null)}
                style={{ marginTop: "10px" }}
            >
                Close
            </button>
            </div>
        </div>
        )}
    </div>
  );
};

export default CategoryPage;